import React, {Component} from 'react';
import {connect} from 'react-redux'
import {sendVerificationRequest, logout} from "store/auth/actions";
import {RaisedButton} from "material-ui";
import {translate} from "react-i18next";

class ConfirmEmail extends Component {

    componentDidMount() {
        this.intv = setInterval(() => {
            if (!this.props.auth.isVerifyingEmail) {
                this.props.tick();
            }
        }, 3000)
    }

    componentWillUnmount() {
        clearInterval(this.intv);
    }

    render() {
        return (
            <div className="page">
                <p>{this.props.t('login_verification_email_sent', {1: this.props.email})}</p>
                {/*<p>Do vaší e-mailové schránky jsme zaslali e-mail s ověřovacím odkazem. Prosím klikněte na odkaz v tomto e-mailu</p>*/}
                <RaisedButton label={this.props.t("login_send_to_other_email")} onClick={this.props.logout}/>
            </div>
        )
    }


}

const mapDispatchToProps = (dispatch) => {
    return {
        tick: () => {
            return dispatch(sendVerificationRequest());
        },
        logout: () => {
            return dispatch(logout());
        }
    }
};
const mapStateToProps = (state) => {
    return {
        email: state.auth.email
    }
};

export default translate()(connect(mapStateToProps, mapDispatchToProps)(ConfirmEmail));


// WEBPACK FOOTER //
// ./src/components/auth/ConfirmEmail.js